export const isoZones = [
    {
            "stateAbbr" : "AL",
            "isoZone" : "46 Gulf",
            "display" : "Alabama"
    },
    {
            "stateAbbr" : "AK",
            "isoZone" : "50 Alaska",
            "display" : "Alaska"
    },
    {
            "stateAbbr" : "AZ",
            "isoZone" : "29 Phoenix",
            "display" : "Arizona - Phoenix Metro"
    },
    {
            "stateAbbr" : "AZ",
            "isoZone" : "41 Mountain",
            "display" : "Arizona remainder"
    },
    {
            "stateAbbr" : "AR",
            "isoZone" : "17 Little Rock",
            "display" : "Arkansas - Little Rock Metro"
    },
    {
            "stateAbbr" : "AR",
            "isoZone" : "43 Southwest",
            "display" : "Arkansas remainder"
    },
    {
            "stateAbbr" : "CA",
            "isoZone" : "18 Los Angeles",
            "display" : "California - Los Angeles Metro"
    },
    {
            "stateAbbr" : "CA",
            "isoZone" : "36 San Francisco",
            "display" : "California - San Francisco Metro"
    },
    {
            "stateAbbr" : "CA",
            "isoZone" : "40 Pacific",
            "display" : "California remainder"
    },
    {
            "stateAbbr" : "CO",
            "isoZone" : "10 Denver",
            "display" : "Colorado - Denver Metro"
    },
    {
            "stateAbbr" : "CO",
            "isoZone" : "41 Mountain",
            "display" : "Colorado remainder"
    },
    {
            "stateAbbr" : "CT",
            "isoZone" : "12 Hartford",
            "display" : "Connecticut - Hartford Metro"
    },
    {
            "stateAbbr" : "CT",
            "isoZone" : "26 New York City",
            "display" : "Connecticut - Tri - State Area"
    },
    {
            "stateAbbr" : "CT",
            "isoZone" : "49 New England",
            "display" : "Connecticut remainder"
    },
    {
            "stateAbbr" : "DE",
            "isoZone" : "30 Philadelphia",
            "display" : "Delaware - Philly Metro"
    },
    {
            "stateAbbr" : "DE",
            "isoZone" : "48 Eastern",
            "display" : "Delaware remainder"
    },
    {
            "stateAbbr" : "DC",
            "isoZone" : "2 Baltimore/Washington",
            "display" : "District of Columbia"
    },
    {
            "stateAbbr" : "FL",
            "isoZone" : "15 Jacksonville",
            "display" : "Florida - Jacksonville Metro"
    },
    {
            "stateAbbr" : "FL",
            "isoZone" : "21 Miami",
            "display" : "Florida - Miami Metro"
    },
    {
            "stateAbbr" : "FL",
            "isoZone" : "47 Southeast",
            "display" : "Florida remainder"
    },
    {
            "stateAbbr" : "GA",
            "isoZone" : "1 Atlanta",
            "display" : "Georgia - Atlanta Metro"
    },
    {
            "stateAbbr" : "GA",
            "isoZone" : "47 Southeast",
            "display" : "Georgia remainder"
    },
    {
            "stateAbbr" : "ID",
            "isoZone" : "41 Mountain",
            "display" : "Idaho"
    },
    {
            "stateAbbr" : "IL",
            "isoZone" : "6 Chicago",
            "display" : "Illinois - Chicago Metro"
    },
    {
            "stateAbbr" : "IL",
            "isoZone" : "34 St. Louis",
            "display" : "Illinois - St. Louis Metro"
    },
    {
            "stateAbbr" : "IL",
            "isoZone" : "44 North Central",
            "display" : "Illinois remainder"
    },
    {
            "stateAbbr" : "IN",
            "isoZone" : "6 Chicago",
            "display" : "Indiana - Chicago Metro"
    },
    {
            "stateAbbr" : "IN",
            "isoZone" : "14 Indianapolis",
            "display" : "Indiana - Indianapolis Metro"
    },
    {
            "stateAbbr" : "IN",
            "isoZone" : "19 Louisville",
            "display" : "Indiana - Louisville Metro"
    },
    {
            "stateAbbr" : "IN",
            "isoZone" : "44 North Central",
            "display" : "Indiana remainder"
    },
    {
            "stateAbbr" : "IA",
            "isoZone" : "28 Omaha",
            "display" : "Iowa - Omaha Metro"
    },
    {
            "stateAbbr" : "IA",
            "isoZone" : "42 Midwest",
            "display" : "Iowa remainder"
    },
    {
            "stateAbbr" : "KS",
            "isoZone" : "16 Kansas City",
            "display" : "Kansas - Kansas City Metro"
    },
    {
            "stateAbbr" : "KS",
            "isoZone" : "42 Midwest",
            "display" : "Kansas remainder"
    },
    {
            "stateAbbr" : "KY",
            "isoZone" : "7 Cincinatti",
            "display" : "Kentucky - Cincinatti Metro"
    },
    {
            "stateAbbr" : "KY",
            "isoZone" : "19 Louisville",
            "display" : "Kentucky - Louisville Metro"
    },
    {
            "stateAbbr" : "KY",
            "isoZone" : "45 Mideast",
            "display" : "Kentucky remainder"
    },
    {
            "stateAbbr" : "LA",
            "isoZone" : "25 New Orleans",
            "display" : "Louisiana - New Orleans Metro"
    },
    {
            "stateAbbr" : "LA",
            "isoZone" : "46 Gulf",
            "display" : "Louisiana remainder"
    },
    {
            "stateAbbr" : "ME",
            "isoZone" : "49 New England",
            "display" : "Maine"
    },
    {
            "stateAbbr" : "MD",
            "isoZone" : "2 Baltimore/Washington",
            "display" : "Maryland - Baltimore/Washington Metro"
    },
    {
            "stateAbbr" : "MD",
            "isoZone" : "48 Eastern",
            "display" : "Maryland remainder"
    },
    {
            "stateAbbr" : "MI",
            "isoZone" : "11 Detroit",
            "display" : "Michigan - Detroit Metro"
    },
    {
            "stateAbbr" : "MI",
            "isoZone" : "44 North Central",
            "display" : "Michigan remainder"
    },
    {
            "stateAbbr" : "MN",
            "isoZone" : "23 Minneapolist/St. Paul",
            "display" : "Minnesota - Minneapolist/St. Paul Metro"
    },
    {
            "stateAbbr" : "MN",
            "isoZone" : "42 Midwest",
            "display" : "Minnesota remainder"
    },
    {
            "stateAbbr" : "MS",
            "isoZone" : "46 Gulf",
            "display" : "Mississippi"
    },
    {
            "stateAbbr" : "MO",
            "isoZone" : "16 Kansas City",
            "display" : "Missouri - Kansas City Metro"
    },
    {
            "stateAbbr" : "MO",
            "isoZone" : "34 St. Louis",
            "display" : "Missouri - St. Louis Metro"
    },
    {
            "stateAbbr" : "MO",
            "isoZone" : "42 Midwest",
            "display" : "Missouri remainder"
    },
    {
            "stateAbbr" : "MT",
            "isoZone" : "41 Mountain",
            "display" : "Montana"
    },
    {
            "stateAbbr" : "NE",
            "isoZone" : "28 Omaha",
            "display" : "Nebraska - Omaha Metro"
    },
    {
            "stateAbbr" : "NE",
            "isoZone" : "42 Midwest",
            "display" : "Nebraska remainder"
    },
    {
            "stateAbbr" : "NV",
            "isoZone" : "41 Mountain",
            "display" : "Nevada"
    },
    {
            "stateAbbr" : "NH",
            "isoZone" : "49 New England",
            "display" : "New Hampshire"
    },
    {
            "stateAbbr" : "NJ",
            "isoZone" : "26 New York City",
            "display" : "New Jersey - New York City Metro"
    },
    {
            "stateAbbr" : "NJ",
            "isoZone" : "30 Philadelphia",
            "display" : "New Jersey - Philadelphia Metro"
    },
    {
            "stateAbbr" : "NJ",
            "isoZone" : "48 Eastern",
            "display" : "New Jersey remainder"
    },
    {
            "stateAbbr" : "NM",
            "isoZone" : "41 Mountain",
            "display" : "New Mexico"
    },
    {
            "stateAbbr" : "NY",
            "isoZone" : "4 Buffalo",
            "display" : "New York - Buffalo Metro"
    },
    {
            "stateAbbr" : "NY",
            "isoZone" : "26 New York City",
            "display" : "New York - New York City Metro"
    },
    {
            "stateAbbr" : "NY",
            "isoZone" : "48 Eastern",
            "display" : "New York remainder"
    },
    {
            "stateAbbr" : "NC",
            "isoZone" : "5 Charlotte",
            "display" : "North Carolina - Charlotte Metro"
    },
    {
            "stateAbbr" : "NC",
            "isoZone" : "47 Southeast",
            "display" : "North Carolina remainder"
    },
    {
            "stateAbbr" : "ND",
            "isoZone" : "42 Midwest",
            "display" : "North Dakota"
    },
    {
            "stateAbbr" : "OH",
            "isoZone" : "7 Cincinatti",
            "display" : "Ohio - Cincinatti Metro"
    },
    {
            "stateAbbr" : "OH",
            "isoZone" : "8 Cleveland",
            "display" : "Ohio - Cleveland Metro"
    },
    {
            "stateAbbr" : "OH",
            "isoZone" : "44 North Central",
            "display" : "Ohio remainder"
    },
    {
            "stateAbbr" : "OK",
            "isoZone" : "27 Oklahoma City",
            "display" : "Oklahoma - Oklahoma City Metro"
    },
    {
            "stateAbbr" : "OK",
            "isoZone" : "37 Tulsa",
            "display" : "Oklahoma - Tulsa Metro"
    },
    {
            "stateAbbr" : "OK",
            "isoZone" : "43 Southwest",
            "display" : "Oklahoma remainder"
    },
    {
            "stateAbbr" : "OR",
            "isoZone" : "32 Portland",
            "display" : "Oregon - Portland Metro"
    },
    {
            "stateAbbr" : "OR",
            "isoZone" : "40 Pacific",
            "display" : "Oregon remainder"
    },
    {
            "stateAbbr" : "PA",
            "isoZone" : "30 Philadelphia",
            "display" : "Pennsylvania - Philadelphia Metro"
    },
    {
            "stateAbbr" : "PA",
            "isoZone" : "31 Pittsburgh",
            "display" : "Pennsylvania - Pittsburgh Metro"
    },
    {
            "stateAbbr" : "PA",
            "isoZone" : "48 Eastern",
            "display" : "Pennsylvania remainder"
    },
    {
            "stateAbbr" : "RI",
            "isoZone" : "49 New England",
            "display" : "Rhode Island"
    },
    {
            "stateAbbr" : "SC",
            "isoZone" : "47 Southeast",
            "display" : "South Carolina"
    },
    {
            "stateAbbr" : "SD",
            "isoZone" : "42 Midwest",
            "display" : "South Dakota"
    },
    {
            "stateAbbr" : "TN",
            "isoZone" : "20 Memphis",
            "display" : "Tennessee - Memphis Metro"
    },
    {
            "stateAbbr" : "TN",
            "isoZone" : "24 Nashville",
            "display" : "Tennessee - Nashville Metro"
    },
    {
            "stateAbbr" : "TN",
            "isoZone" : "45 Mideast",
            "display" : "Tennessee remainder"
    },
    {
            "stateAbbr" : "TX",
            "isoZone" : "9 Dallas/Fort Worth",
            "display" : "Texas - Dallas/Fort Worth Metro"
    },
    {
            "stateAbbr" : "TX",
            "isoZone" : "13 Houston",
            "display" : "Texas - Houston Metro"
    },
    {
            "stateAbbr" : "TX",
            "isoZone" : "43 Southwest",
            "display" : "Texas remainder"
    },
    {
            "stateAbbr" : "UT",
            "isoZone" : "35 Salt Lake City",
            "display" : "Utah - Salt Lake City Metro"
    },
    {
            "stateAbbr" : "UT",
            "isoZone" : "41 Mountain",
            "display" : "Utah remainder"
    },
    {
            "stateAbbr" : "VT",
            "isoZone" : "49 New England",
            "display" : "Vermont"
    },
    {
            "stateAbbr" : "VA",
            "isoZone" : "2 Baltimore/Washington",
            "display" : "Virginia - Baltimore/Washington Metro"
    },
    {
            "stateAbbr" : "VA",
            "isoZone" : "33 Richmond",
            "display" : "Virginia - Richmond Metro"
    },
    {
            "stateAbbr" : "VA",
            "isoZone" : "47 Southeast",
            "display" : "Virginia remainder"
    },
    {
            "stateAbbr" : "WA",
            "isoZone" : "32 Portland",
            "display" : "Washington - Portland Metro"
    },
    {
            "stateAbbr" : "WA",
            "isoZone" : "40 Pacific",
            "display" : "Washington remainder"
    },
    {
            "stateAbbr" : "WV",
            "isoZone" : "45 Mideast",
            "display" : "West Virginia"
    },
    {
            "stateAbbr" : "WI",
            "isoZone" : "22 Milwaukee",
            "display" : "Wisconsin - Milwaukee Metro"
    },
    {
            "stateAbbr" : "WI",
            "isoZone" : "42 Midwest",
            "display" : "Wisconsin remainder"
    },
    {
            "stateAbbr" : "WY",
            "isoZone" : "41 Mountain",
            "display" : "Wyoming"
    }
];

export default isoZones;